import GenericSidebar from './generic-sidebar';

export default GenericSidebar;
